import { create } from 'zustand'

type NavigationStoreProps = {
  navOpen: boolean
}

export type NavigationStoreActions = {
  setNavOpen: (state: boolean) => void
  toggleNav: () => void
}

type NavigationStore = NavigationStoreProps & NavigationStoreActions

const INITIAL_STATE = (): NavigationStoreProps => ({
  navOpen: false,
})

export const useNavigationStore = create<NavigationStore>((set) => ({
  ...INITIAL_STATE(),
  setNavOpen: (state) => set({ navOpen: state }),
  toggleNav: () => set((state) => ({ navOpen: !state.navOpen })),
}))
